import { render, staticRenderFns } from "./DevPurchArch_bak.vue?vue&type=template&id=a2bf45da&scoped=true"
import script from "./DevPurchArch_bak.vue?vue&type=script&lang=js"
export * from "./DevPurchArch_bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf45da",
  null
  
)

export default component.exports